import { Injectable } from '@angular/core';
import { IConfiguration } from '@gishub/domain';

declare global {
  interface Window {
    __ENV: {
      appEnvironment: string;
      apiUrl: string;
      proxyUrl: string;
      appName: string;
      version: string;
      recaptchaSiteKey: string;
    };
  }
}

@Injectable({ providedIn: 'root' })
export class Configuration implements IConfiguration {
  private get env() {
    // ❌ SIN fallback: Si window.__ENV no existe, lanzamos error explícito
    if (!window.__ENV) {
      throw new Error(
        '⚠️ Configuration: window.__ENV no está definido. ' +
        '¿Olvidaste cargar assets/env.js en index.html o generar el archivo en Docker?'
      );
    }
    return window.__ENV;
  }

  get isProduction(): boolean {
    return this.env.appEnvironment === 'production';
  }

  get apiUrl(): string {
    return this.env.apiUrl;
  }
  get proxyUrl(): string {
    return this.env.proxyUrl;
  }

  get appName(): string {
    return this.env.appName;
  }

  get version(): string {
    return this.env.version;
  }

  get recaptchaSiteKey(): string {
    return this.env.recaptchaSiteKey;
  }

  /** Minutos de inactividad antes del aviso de sesión (hardcoded: 25). */
  get sessionIdleTimeoutMinutes(): number {
    return 25;
  }

  /** Minutos de gracia con el aviso visible antes de cerrar la sesión (hardcoded: 5). */
  get sessionWarningGraceMinutes(): number {
    return 5;
  }
}